@use '../../styling/colors.scss' as *;
@use '../../styling/form-controls.scss' as *;

.CheckedIndicator {
  @extend %form-control-border;

  display: inline-block;
  border-radius: 4px;
  height: 16px;
  width: 16px;
  min-width: 16px;
  position: relative;
  background: $theme-color-background;
  border-color: $theme-color-checkbox-border;
  cursor: pointer;

  &::before {
    content: ' '; // must be a space
    position: absolute;
    width: 10px;
    height: 10px;
  }

  &.isChecked {
    background: $theme-color-checkbox-checked-background;
    border-color: transparent;

    &::before {
      content: url('../../styling/svg/BootstrapCheck.svg');
    }
  }

  &.isIndeterminate {
    background: $theme-color-checkbox-checked-background;
    border-color: transparent;

    &::before {
      content: url('../../styling/svg/BootstrapDash.svg');
    }
  }

  &.CheckedReadOnly {
    background: $theme-color-checkbox-disabled-checked-background;
    border-color: transparent;
    cursor: default;
  }

  &.UncheckedReadOnly {
    background: $color-input-readonly;
    border-color: $theme-color-checkbox-disabled-border;
    cursor: default;
  }
}